var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMicrosoftIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H16V16H0Z",
    fill: "#f3f3f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1,1H7.936V7.936H1Z",
    transform: "translate(-0.306 -0.306)",
    fill: "#f35325"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,1h6.936V7.936H12Z",
    transform: "translate(-3.63 -0.306)",
    fill: "#81bc06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1,12H7.936v6.936H1Z",
    transform: "translate(-0.306 -3.63)",
    fill: "#05a6f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12h6.936v6.936H12Z",
    transform: "translate(-3.63 -3.63)",
    fill: "#ffba08"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicrosoftIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/microsoftIcon.b8948848.svg";
export { ForwardRef as ReactComponent };